import { Button, Modal, Row } from "antd";
import FormUser, {
  transformUserToFormValues,
} from "../../components/forms/FormUser";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import TableUsers from "../../components/tables/TableUsers/TableUsers";
import {
  useFetchRolesQuery,
  useLazyFetchUsersQuery,
} from "../../features/api/apiSlice";
import { useCrudUser } from "../../features/api/crud/hooks/useCrudUser";
import styles from "./PageUsers.module.scss";
import { useModal } from "./useModal";
import { useState } from "react";
import { modalProps } from "../../features/modals/modalProps";

const PageUsers: React.FC = () => {
  const [fetchUsers, { data: usersData, isFetching }] =
    useLazyFetchUsersQuery();

  const { data: rolesData } = useFetchRolesQuery();

  // This search state (in the parent component) is used to trigger a re-fetch of the users data with the search query param
  const [search, onSearchChanged] = useState("");

  const {
    isModalOpen,
    modalItemId,
    onShowModal,
    onHideModal,
    onModifyShowModal,
  } = useModal();

  const {
    createUser,
    isCreating,
    updateUser,
    isUpdating,
    onDelete,
    isDeleting,
  } = useCrudUser(modalItemId, fetchUsers, search, onHideModal);

  const formMode = modalItemId ? "update" : "create";

  const modalUser = usersData?.results?.find((user) => user.id === modalItemId);

  return (
    <PageLayout pageContainerClassName={styles.root}>
      <div className={styles.top}>
        <h1>Les utilisateurs</h1>
        <Button type="primary" onClick={onShowModal}>
          CrÃ©er un nouvel utilisateurs
        </Button>
      </div>
      <Row>
        <TableUsers
          eventsData={usersData}
          fetchData={fetchUsers}
          isLoading={isFetching || isDeleting}
          onModify={onModifyShowModal}
          onDelete={onDelete}
          onSearchChangedFromProps={onSearchChanged}
        />
      </Row>
      <Modal
        {...modalProps}
        title={
          formMode === "create" ? (
            <p>CrÃ©er un nouvel utilisateur</p>
          ) : (
            <p>Modifier un utilisateur</p>
          )
        }
        footer={
          <>
            <Button
              type="default"
              onClick={onHideModal}
              disabled={isCreating || isUpdating}
            >
              Annuler
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              disabled={false}
              loading={isCreating || isUpdating}
              form="form-user"
            >
              {formMode === "create" ? "Ajouter" : "Mettre Ã  jour"}
            </Button>
          </>
        }
        loading={isCreating}
        open={isModalOpen}
        onCancel={onHideModal}
      >
        <>
          {/*
          {Boolean(modalItemId) && <p>Item ID: {modalItemId}</p>}
          <br /> */}
          <br />
          <FormUser
            // "key" is used to reset the form. Needed for defaultValues to be re-considered when modalUser changes
            key={modalUser?.id}
            onSubmit={formMode === "create" ? createUser : updateUser}
            defaultValues={transformUserToFormValues(modalUser)}
            roles={rolesData?.results}
            formMode={formMode}
          />
        </>
      </Modal>
    </PageLayout>
  );
};

export default PageUsers;
